module.exports = __webpack_public_path__ + "img/13_bg.b09aeb20.jpg";